import { useTraderStatus } from "../../context/TraderStatusContext";
import { engineState } from "../../lib/riskMath";

/* armed / paused / halted — whether a rule chip can actually place an order.
 * A chip reading "BUY PUT" while the autotrader is off (or the kill switch is
 * on) used to look exactly like one that was about to trade. */
const STYLE = {
  armed: { cls: "bg-emerald-500/20 text-emerald-200", tip: "Autotrader ON: this rule can place orders" },
  paused: { cls: "bg-slate-600/60 text-slate-200", tip: "Autotrader OFF: the rule is read, nothing is ordered" },
  halted: { cls: "bg-rose-600 text-white", tip: "Kill switch ON: no new entries from any rule" },
};

export function useEngineState() {
  return engineState(useTraderStatus());
}

export function EngineStateTag({ state }) {
  const s = state && STYLE[state];
  if (!s) return null;
  return (
    <span title={s.tip} className={`shrink-0 rounded px-1 py-px text-[9px] font-black uppercase tracking-wider ${s.cls}`}>
      {state}
    </span>
  );
}

export default EngineStateTag;
